var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pa-4"},[_c('code',[_vm._v(" /* 原理: 通过overflow */ /* overflow: visible; */ overflow: hidden; ")])])
}]

export { render, staticRenderFns }